import Reflux from "reflux";

import Immutable from "immutable";
import SiteDesignStore from "../stores/SiteDesignStore";
import SiteActions from "../actions/SiteActions";

const DesignThemeStore = Reflux.createStore({
  storeName: 'DesignThemeStore',
  init() {
    this.listenTo(SiteDesignStore, this.onDesignChange);

    this.theme = Immutable.Map();
    this.styleNames = Immutable.List();
  },

  onDesignChange() {
    var siteDesign = SiteDesignStore.getDesign();
    var theme = siteDesign.theme;

    if (theme !== null && theme !== this.theme) {
      this.theme = theme;

      var styles = this.theme.get("styles");
      this.styleNames = styles.valueSeq().map((style) => style.get("name"));

      this.trigger(this.theme);
    }
  },

  getTheme() {
    return this.theme;
  },

  getFonts() {
    return this.theme.get("fonts", false);
  },

  getStyles() {
    return this.theme.get("styles", false);
  },

  getButtonStyles() {
    return this.theme.get("buttons", false);
  },

  getStyleNames() {
    return this.styleNames;
  },

  getColors() {
    return this.theme.get("colors", Immutable.List());
  },

  getInitialState() {
    return this.theme;
  },
});

export default DesignThemeStore;
